import BookableClasses from 'components/BookingPageComponents/BookableClasses'
import { ClassBookingForm } from 'components/BookingPageComponents/ClassBookingForm'
import DayTabsContainer from 'components/BookingPageComponents/dayTabsContainer/DayTabsContainer'
import BookingPageLayout from 'components/BookingPageComponents/Layout'
import BookingPageSideBar from 'components/BookingPageSideBar/BookingPageSideBar'
import { EmptyListPlaceholder } from 'components/EmptyPlaceholders/empty-list'
import Translation from 'components/Translation'
import AppointmentPurchaseContainer from 'context/appointmentPurchaseContext/AppointmentPurchaseContainer'
import {
    getDateFromYmd,
    useBookingPageContext,
} from 'context/bookingContext/BookingPageContainer'
import { useTenantContext } from 'context/TenantContext'
import React, { ReactElement, useEffect, useState } from 'react'
import { denormalizeGroupClass } from 'services/service'
import { BookingForm } from 'types/booking'
import { CalendarApiItem, CalendarSlotItem } from 'types/calendar'
import { OrderType } from 'types/order'
import { useFetch } from 'utils/fetch-helper'
import { FetchMethods } from 'utils/types'
import { useAuth } from 'context/AuthContext'
import { useAppContext } from 'context/AppContext'
import MobileNavBar from 'components/BookingPageComponents/MobileNavBar'
import { isIframeEmbedded } from 'utils/iframe-resize'
import { DayTabMode } from 'components/BookingPageComponents/DayTabs'
import BookingHomeButton from 'components/BookingPageComponents/BookingHomeButton'
import CalendarContainer from 'components/BookingPageComponents/CalendarContainer/CalendarContainer'
import CalendarContainerButton from 'components/BookingPageComponents/CalendarContainer/CalendarContainerButton'
import { classNames } from '@progress/kendo-react-common'
import { CALENDAR_DISPLAY_OPTIONS } from 'components/Modals/CustomBookingPage/BookingPageOptions'
import {
    getFirstAndLastDay,
    getFullTimeZone,
    toYmd,
} from 'utils/string-localization-helper'
import BookingPageTopBar from 'components/BookingPageSideBar/BookingPageTopBar'
import getConfig from 'next/config'
import getAccountTimeZone from 'utils/date-and-time-helper'
/*
-> this is refactored code, only this route is added but the logic remains same except some of the state tweaks. 
-> there are couple of fixes what weren't there before
    a. location is not undefined now 
    b. location filter fixed (previously on changing the location, classes weren't accurately filtered)
    c. date issues (sometimes classes would appear under wrong date)
-> when a user pass past date in params, it changes it to current date

*/

const Classes = () => {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
    const { tenant, staff, services, primaryColor } = useTenantContext()
    const { user_profile } = useAuth()
    const { locale } = useAppContext()
    const { NEXT_PUBLIC_STATIC_DOMAIN } = getConfig().publicRuntimeConfig

    const {
        calendarDisplay,
        toDate,
        fromDate,
        activeDate,
        router,
        shouldRefetch,
        setShouldRefetch,
    } = useBookingPageContext()
    const [filteredClasses, setFilteredClasses] = useState<
        CalendarSlotItem[]
    >([])
    const [groupClasses, setGroupClasses] = useState<CalendarSlotItem[]>([])
    const [selected_class, openClassBookingForm] =
        useState<CalendarSlotItem>()
    const [bookingData, setBookingData] = useState<BookingForm>({
        timezone,
        order_type: OrderType.SERVICE,
    })
    const accountTimezone = getAccountTimeZone()

    const [available_dates, setAvailableDates] = useState<string[]>([])
    const isEmbeded = isIframeEmbedded()
    const [show_calendar, setShowCalendar] = useState(
        calendarDisplay == CALENDAR_DISPLAY_OPTIONS[1].value
    )

    const {
        data: offerings_xhr,
        is_loading: is_loading_gpcs,
        doFetch: fetchGroupClasses,
    } = useFetch(
        `/v1/offerings/group-class?from=${router?.query?.d}&to=${router?.query?.d}&tenantId=${tenant?.id}&locationId=${router?.query?.l}`,
        FetchMethods.GET,
        !!router.query.d && !!tenant?.id && !!router.query.l
    )

    const {
        data: monthly_available_xhr,
        is_loading: is_loading_monthly_gpcs,
        doFetch: fetchMonthlyAvailableDates,
    } = useFetch(
        `/v1/offerings/get-avail-dates?locationId=${router?.query?.l}`,
        FetchMethods.GET,
        false
    )

    useEffect(() => {
        if (shouldRefetch) {
            fetchGroupClasses()
        }
        setShouldRefetch(false)
    }, [shouldRefetch])

    useEffect(() => {
        setShowCalendar(
            calendarDisplay == CALENDAR_DISPLAY_OPTIONS[1].value
        )
    }, [calendarDisplay])

    useEffect(() => {
        if (show_calendar && (router.query.d || activeDate)) {
            const date = router.query.d
                ? getDateFromYmd(router.query.d as string)
                : activeDate
            const [firstDay, lastDay] = getFirstAndLastDay(date)
            const lookup = lastDay.getDate() - firstDay.getDate()
            fetchMonthlyAvailableDates(
                null,
                `&date=${toYmd(firstDay)}&lookupDays=${lookup}`
            )
        }
    }, [show_calendar, router.query.d, activeDate])

    useEffect(() => {
        if (monthly_available_xhr?.length) {
            setAvailableDates(monthly_available_xhr)
        } else {
            setAvailableDates([])
        }
    }, [monthly_available_xhr])

    //mapping data from api to state
    function processGroupClasses() {
        if (offerings_xhr?.length > 0) {
            const recs = offerings_xhr as CalendarApiItem[]
            const group_classes: CalendarSlotItem[] = []
            if (!!recs?.length) {
                recs.forEach((rec, idx) => {
                    if (!rec.deletedAt) {
                        const denormed = denormalizeGroupClass(rec, idx)
                        if (denormed) {
                            group_classes.push(denormed)
                        }
                    }
                })

                setGroupClasses([...group_classes])
                showClassesToday([...group_classes])
            }
        } else {
            showClassesToday([])
        }
    }

    //for filter dropdown
    const deduped_classes: CalendarSlotItem[] = []
    groupClasses.forEach((cls: CalendarSlotItem) => {
        const already_added: CalendarSlotItem[] = deduped_classes.filter(
            ({ service_id }) => service_id == cls.service_id
        )
        if (already_added.length === 0) {
            deduped_classes.push(cls)
        }
    })

    //it shows selected day classes
    function showClassesToday(group_classes: CalendarSlotItem[]) {
        const group_classes_today = group_classes.filter(
            (gc: CalendarSlotItem) => {
                let service = services.find(
                    (service) => service.id == gc.service_id
                )
                return (
                    service?.is_public ||
                    router.query.serviceId == gc.service_id
                )
            }
        )
        setFilteredClasses(group_classes_today)
    }

    useEffect(() => {
        processGroupClasses()
    }, [offerings_xhr, activeDate, toDate, fromDate])

    //to access from params
    useEffect(() => {
        if (router?.query?.classId && services && staff) {
            let found = filteredClasses.find(
                (item) => item?.id === router?.query?.classId
            )

            if (found) {
                found.staff_photo = staff.find(
                    (s) => s.id == found?.staff_id
                )?.user?.image_url
                found.imageUrl = services.find(
                    (s) => s.id == found?.service_id
                )?.image_url
                openClassBookingForm(found)
            } else {
                openClassBookingForm(undefined)
            }
        }
    }, [router.query.classId, filteredClasses, staff, services])

    //get data from local storage if present
    useEffect(() => {
        const keys = ['first_name', 'last_name', 'email', 'phone']

        if (user_profile?.user) {
            const user = user_profile?.user
            setBookingData((prev: any) => ({
                ...prev,
                first_name: user.firstName,
                last_name: user.lastName,
                email: user.email,
                phone: user.phone || localStorage.getItem('phone') || '',
            }))
        } else {
            keys.map((key) => {
                //@ts-ignore
                if (localStorage.getItem(key) && !bookingData[key]) {
                    setBookingData((prev: any) => ({
                        ...prev,
                        [key]: localStorage.getItem(key),
                    }))
                }
            })
        }
    }, [selected_class])

    const image_url = selected_class?.imageUrl
        ? selected_class?.imageUrl
        : `https://${NEXT_PUBLIC_STATIC_DOMAIN}/images/no_services.svg`

    return (
        <>
            <div className="h-screen bg-white overflow-x-hidden">
                <main
                    className={`w-full flex flex-col lg:flex-row ${
                        isEmbeded ? 'bg-transparent' : 'bg-white'
                    }  
                flex-1 h-screen`}
                >
                    <BookingPageTopBar />
                    <section className="absolute my-20 w-full k-pt-10">
                        <div className='mx-10 custom-space'>

                     
                        <div className="flex flex-col gap-2 p-5 px-0 appointment-title">
                            {/* <BookingHomeButton /> */}
                            <div className="flex flex-wrap justify-between gap-5 items-center">
                                <Translation
                                    content_key={
                                        'booking_page.book_a_class'
                                    }
                                    render_as="strong"
                                    className="text-black"
                                />
                                <CalendarContainerButton />
                            </div>
                        </div>
                        <div
                            className={classNames(
                                'flex p-4',
                                show_calendar ? 'flex-row' : 'flex-col'
                            )}
                        >
                            {console.log(
                                !selected_class && !show_calendar,
                                'toDate'
                            )}

                            {!selected_class && !show_calendar && (
                                <DayTabsContainer
                                    mode={DayTabMode.CLASSES}
                                />
                            )}
                            <div className="grid grid-cols-12 gap-4 w-full ">
                                {!selected_class && show_calendar && (
                                    <div className="col-span-3">
                                        <div className="mx-10"></div>
                                        <CalendarContainer
                                            dates={available_dates}
                                        />
                                    </div>
                                )}
                                <div
                                    className={
                                        !selected_class && show_calendar
                                            ? 'col-span-12'
                                            : 'col-span-12'
                                    }
                                >
                                    <div className="w-full border border-gray-200 rounded-md class-dayntime-wrap">
                                        <div className="flex lg:flex-row lg:items-center  flex-col mx-3 sm:mx-4 border-b-4 class-dayntime">
                                            <h3
                                                className="font-display text-lg lg:text-xl my-6 mt-6 lg:px-0 px-4 mr-4 text-primary"
                                                style={{
                                                    color: primaryColor,
                                                }}
                                            >
                                                {activeDate.toLocaleDateString(
                                                    locale,
                                                    {
                                                        weekday: 'long',
                                                        month: 'long',
                                                        day: 'numeric',
                                                        year: 'numeric',
                                                    }
                                                )}{' '}
                                            </h3>
                                            {accountTimezone && (
                                                <span className="text-white  hidden  sm:flex items-center text-[11px] h-10  tracking-widest leading-none my-2 lg:mt-0">
                                                    <span
                                                        className="bg-primary-light px-3 h-7 mt-2 uppercase  rounded-full mx-2 flex items-center"
                                                        style={{
                                                            backgroundColor:
                                                                primaryColor,
                                                        }}
                                                    >
                                                        {' '}
                                                        {getFullTimeZone(
                                                            accountTimezone,
                                                            locale
                                                        )}
                                                        {/* {accountTimezone} */}
                                                    </span>
                                                </span>
                                            )}
                                        </div>
                                        {is_loading_gpcs ||
                                        !filteredClasses.length ? (
                                            <EmptyListPlaceholder
                                                isImage={false}
                                                src={`https://${NEXT_PUBLIC_STATIC_DOMAIN}/images/no_services.svg`}
                                                alt="No Services"
                                                messages={[
                                                    'no_classes_today_1',
                                                    'no_classes_today_2',
                                                ]}
                                            />
                                        ) : (
                                            <div className="px-3 sm:px-4">
                                                {!!filteredClasses.length &&
                                                !selected_class ? (
                                                    <BookableClasses
                                                        bookItem={(
                                                            item: CalendarSlotItem
                                                        ) => {
                                                            setBookingData({
                                                                ...bookingData,
                                                                service_id:
                                                                    item.service_id,
                                                                price: item.price,
                                                                amount: item.price,
                                                            })
                                                            openClassBookingForm(
                                                                item
                                                            )
                                                            router.replace({
                                                                query: {
                                                                    ...router.query,
                                                                    classId:
                                                                        item?.id,
                                                                    s: item?.service_id,
                                                                },
                                                            })
                                                        }}
                                                        items={
                                                            filteredClasses
                                                        }
                                                    />
                                                ) : (
                                                    ''
                                                )}
                                            </div>
                                        )}
                                        {selected_class && (
                                            <AppointmentPurchaseContainer>
                                                <ClassBookingForm
                                                    availability_id={
                                                        selected_class.availability_id as string
                                                    }
                                                    booking_data={
                                                        bookingData
                                                    }
                                                    duration={
                                                        selected_class.duration as number
                                                    }
                                                    end={
                                                        selected_class.end as Date
                                                    }
                                                    location_id={
                                                        selected_class.location_id as string
                                                    }
                                                    location_name={
                                                        selected_class.location_name as string
                                                    }
                                                    price={
                                                        selected_class.price as number
                                                    }
                                                    service_name={
                                                        selected_class.service_name as string
                                                    }
                                                    staff_name={
                                                        selected_class.staff_name as string
                                                    }
                                                    staff_photo={
                                                        selected_class.staff_photo as string
                                                    }
                                                    start={
                                                        selected_class.start as Date
                                                    }
                                                    tenant_id={
                                                        tenant?.id as string
                                                    }
                                                    onCancel={() => {
                                                        if (
                                                            router?.query
                                                                ?.classId
                                                        )
                                                            delete router
                                                                .query
                                                                .classId
                                                        router.push({
                                                            pathname:
                                                                '/book/classes',
                                                            query: {
                                                                ...router.query,
                                                            },
                                                        })
                                                        openClassBookingForm(
                                                            undefined
                                                        )
                                                    }}
                                                    imageUrl={image_url}
                                                    setBookingData={
                                                        setBookingData
                                                    }
                                                    group_class_id={
                                                        selected_class.id
                                                    }
                                                    group_class_name={
                                                        selected_class.group_class_name
                                                    }
                                                    service_type={
                                                        selected_class.service_type
                                                    }
                                                    service_id={
                                                        selected_class.service_id
                                                    }
                                                />
                                            </AppointmentPurchaseContainer>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        </div>
                    </section>
                    <MobileNavBar />
                </main>
            </div>
        </>
    )
}

Classes.getLayout = function getLayout(page: ReactElement) {
    return <BookingPageLayout>{page}</BookingPageLayout>
}

export default Classes
